export default {
  
  en: {
    id: 'ID',
    country: 'Country',
    createTime: 'Create Time',
    custMobile: 'Customer Phone',
    custEmail: 'Customer Email',
    app: 'APP',
    status: 'Status',
    status1: 'Don\'t Handle',
    status2: 'Handle Complete',
    type: 'Type',
    firstLevelQuestion: 'First Level Label',
    secondLevelQuestion: 'Second Level Label',
    complainChannel: 'Complain Channel',
    custAppeal: 'CUstomer Appeal',
    attachmentCode: 'Attachment',
    attachment: 'Attachment',
    collectionDate: 'Collection Date',
    collectionUser: 'Collection User',
    collectionMobile: 'Collection Mobile',
    remark: 'Remark',
    action: 'Operate',
    custQueryData: 'Mobile/Email',
    createdTime: 'Create Time',
    days: 'Time Range',
    workOrderDetail: 'Detail',
    status_0: 'New',
    status_1: 'Close',
    status_2: 'Customer Service Processing',
    status_3: 'Balance Account Processing',
    status_4: 'Collection Processing',
    status_5: 'Product Processing',
    status_6: 'System Processing',
    status_7: 'Customer Service Manager Processing',
    type_1: 'Complain',
    type_2: 'Consult',
    type_0: 'unknown',
    firstLevelQuestion_1: 'App Problem',
    firstLevelQuestion_2: 'Collection',
    firstLevelQuestion_3: 'Advertise',
    firstLevelQuestion_4: 'Log out',
    firstLevelQuestion_5: 'Loan',
    firstLevelQuestion_6: 'Repayment',
    firstLevelQuestion_7: 'Rollover',
    firstLevelQuestion_8: 'Refund',
    secondLevelQuestion_1_1: 'Product function BUG',
    secondLevelQuestion_1_2: 'localization issues',
    secondLevelQuestion_1_3: 'How to use it',
    secondLevelQuestion_1_4: 'Modify Personal Information',
    secondLevelQuestion_1_5: 'Consult download address',
    secondLevelQuestion_2_1: 'violent collection',
    secondLevelQuestion_2_2: 'collector fraud',
    secondLevelQuestion_3_1: 'ad fraud',
    secondLevelQuestion_4_1: 'delete account',
    secondLevelQuestion_5_1: 'interest tax rate',
    secondLevelQuestion_5_2: 'Loan amount',
    secondLevelQuestion_5_3: 'repayment cycle',
    secondLevelQuestion_5_4: 'Arrival time',
    secondLevelQuestion_5_5: 'loan rejection',
    secondLevelQuestion_5_6: 'loan cancellation',
    secondLevelQuestion_6_1: 'The repayment has not taken effect/the system problem cannot repay the payment/the payment transfer limit cannot be repaid/multiple repayments/withholding',
    secondLevelQuestion_6_2: 'Consultation on how to repay the loan/consultation on credit information',
    secondLevelQuestion_7_1: 'Extended payment is understood as partial payment / extended payment has been paid but not effective',
    secondLevelQuestion_7_2: 'Inquire about Rollover Payments',
    secondLevelQuestion_8_1: 'Request a refund',
    secondLevelQuestion_8_2: 'Inquiry about refund arrival time',
    complainChannel_1: 'whatsapp',
    complainChannel_2: 'Phone',
    complainChannel_3: 'Email',
    complainChannel_4: 'Crisp license company',
    complainChannel_5: 'Regulatory Authority',
    complainChannel_6: 'payment institution',
    complainChannel_7: 'court',
    complainChannel_8: 'Procuratorate',
    complainChannel_9: 'Collection Hotline',
    complainChannel_10: 'User Submissions',
    custAppeal_1: 'quick approval',
    custAppeal_2: 'Refund',
    custAppeal_3: 'normal repayment',
    custAppeal_4: 'increase quota',
    custAppeal_5: 'Fast payment',
    custAppeal_6: 'Smooth use of APP',
    custAppeal_7: 'deduction',
    custAppeal_8: 'change order status',
    custAppeal_9: 'lower interest rates',
    custAppeal_10: 'Extend the repayment period',
    custAppeal_11: 'deferment of repayment',
    custAppeal_12: 'cancel loan order',
    custAppeal_13: 'other',
    canPass_1: 'yes',
    canPass_2: 'no',
    item: 'item',
    value: 'Value',
    lastTwoWeekValue: 'Last Two Week',
    lastWeekValue: 'Last Week',
    rate: 'Rate',
    dateLabel: 'Date Label',
    reportType: 'Report Type',
    totalCount: 'Total',
    complaint: 'Complaint',
    consult: 'Consult',
    reportType_1: 'Day',
    reportType_2: 'Week',

    dictType: 'Dict Type',
    dictKey: 'Dict Key',
    dictValue: 'Dict Value',
    dictStatus: 'Status',
    dictSort: 'Sort',
    operate: 'Operate',
    dictStatus_0: 'enable',
    dictStatus_1: 'disable',

    version: 'Version',
    versionContent: 'Content',
    forceUpdate: 'Force update',
    downloadUrl: 'Download Url',
    forceUpdate_0: 'Dont force update',
    forceUpdate_1: 'Force update',
    updateTime: 'Update Time',
    proportion: 'proportion',
    account: 'Customer Service Account',
    questionV1: 'Question Label',
    inputOptRemark: 'Please enter operation notes',
    optRemarkMustNotNull: "Operation notes cannot be empty",
    optRemark: 'Operter Remark',
    questionV1_undefined: ' ',
    questionV1_0: ' ',
    questionV1_1: 'loan bug',
    questionV1_2: 'repayment bug',
    questionV1_3: 'OTP',
    questionV1_4: 'violent collection',
    questionV1_5: 'collector fraud',
    questionV1_6: 'ad fraud',
    questionV1_7: 'Review time is too long',
    questionV1_8: 'Arrival time too long',
    questionV1_9: 'loan rejection',
    questionV1_10: 'loan cancellation',
    questionV1_11: 'The repayment has not taken effect',
    questionV1_12: 'multiple repayments',
    questionV1_13: 'withholding',
    questionV1_14: 'credit information',
    questionV1_15: 'Extended payment is understood as partial payment',
    questionV1_16: 'Account Information Modification',
    days_all: 'All',
    days_yesterday: 'Yesterday',
    days_today: 'Today',
    days_last7days: 'Last 7 Days',
    days_last1month: 'Last 1 Month',
    days_other: 'Other',
    approve: 'approval',
    operateType: 'Operate Type',
    operateType_0: 'approval reject',
    operateType_1: 'approval pass',
    operateType_2: 'deliver to collection',
    operateType_3: 'additional materials',
    processFlow: 'Work Flow',
    nodeId: 'Node',
    businessNode: 'Business Node',
    businessNode_cs_receive_complaint: 'Customer service receive cpmplaint',
    businessNode_coll_receive_complaint: 'Collection receive complaint',
    businessNode_cs_add_work_order: 'Customer Service add work order',
    businessNode_coll_add_work_order: 'Collection add work order',
    businessNode_notice_coll: 'System notice collection',
    businessNode_notice_ba: 'System notice balance account',
    businessNode_notice_cs: 'System notice customer service',
    businessNode_notice_pro: 'System notice product',
    businessNode_notice_cs_send_warning: 'System notice customer service send warning letter',
    businessNode_cs_back_visit: 'Customer service back visit',
    businessNode_ba_approve: 'Balance account approve',
    businessNode_coll_examine_coll_process: 'Collection examine collect process',
    businessNode_pro_handle_problem: 'Product handle problem',
    businessNode_notice_cs_manage: 'System notifies customer service manager',
    businessNode_cs_manage_replace_collection_user: 'The customer service manager replaces the collector',
    itNode: 'IT node',
    itNode_receive_complaint: 'Receive complaint',
    itNode_add_work_order: 'Add Work Order',
    itNode_notice_coll: 'Notice Collection',
    itNode_notice_cs: 'Notice Customer Service',
    itNode_notice_ba: 'Notice Balance Account',
    itNode_notice_pro: 'Notice Product',
    itNode_send_warning: 'Send Warning',
    itNode_approve: 'Approve',
    itNode_cs_back_visit: 'Customer Service Back Visit',
    itNode_coll_examine: 'Collection Examine',
    itNode_notice_cs_manage: 'Notify customer service manager',
    itNode_replace_collection_user: 'replace collector',
    nodeType: 'Node Type',
    nodeType_0: 'Receive complaint',
    nodeType_1: 'Add Work Order',
    nodeType_2: 'Notice',
    nodeType_3: 'Approve',
    operater: 'Operator',
    flowStatus: 'Status',
    flowStatus_0: 'Processing',
    flowStatus_1: 'Close',
    repair: 'Repair',
    repairNotice: 'Repair stuck process case',
    operateTime: 'operating time',
    approveResult: 'Approval comments',
    uploadImage: 'upload image',
    upload: 'Upload',
    nextApproveRole: 'subordinate approval role',
    approveRole_0: 'system',
    approveRole_1: 'customer service',
    approveRole_2: 'debt cancellation',
    approveRole_3: 'collection',
    approveRole_4: 'product',
    approveRole_5: 'Customer Service Manager',
    nextApproveUser: 'next level approver',
    hasImage: 'With pictures',
    workFlowType: 'Work order type',
    workFlowType_common: 'common',
    workFlowType_violentCollection: 'violent collection',
    workFlowType_violentCollectionForAppUser: 'violent collection',
    workFlowType_balanceAccountForCustomerService: 'balance problem',
    workFlowType_balanceAccountForCollcetor: 'balance problem',
    workFlowType_preLoan: 'product problem',
    workFlowType_commonForCustomerServiceManage: 'common',
    workFlowType_violentCollectionForCustomerServiceManage: 'violent collection',
    workFlowType_balanceAccountForCustomerServiceManage: 'balance problem',
    workFlowType_preLoanForCustomerServiceManage: 'product problem',
    baAmount: 'amount of debt canceled',
    decision: 'decision',
    decision_1: 'change the collector',
    decision_2: 'product department is already aware of',
    decision_3: 'debt deducted or canceled',
    decision_4: 'total free debt cancellation',
    decision_5: 'debt cancellation with principal refunded',
    decision_6: 'free extension',
    decision_7: 'extension deducted',
    decision_8: 'refund',
    decision_9: 'customer fraud',
    imageLoadingNotice: 'Image uploading...',
    operateTypeNotice: 'Please select approval comments',
    productRemarkNotice: 'Please fill in the remarks',
    unknow: 'unknown',
    create: 'Create Work Order',
    WorkOrderCreate: 'Create Work Order',
    workOrderCreate: 'Create Work Order',
    custId: 'customer ID',
    orderNo: 'order number',
    workFlowTypeNotice: 'Please select a work order type',
    questionV1Notice: 'Please select a question label',
    approvelUserNotice: 'Please select a subordinate approver',
    custMobileAndCustEmailNotice: 'Please enter the customer\'s mobile phone number or email',
    appsNotice: 'Please choose package',
    complainChannelNotice: 'Please select a complaint channel',
    processFlows: 'Circulation history',
    video: 'Video',
    videoPreviewNotice: 'Your browser does not support',
    videoSizeNotice_pre: 'The maximum video support is ',
    videoSizeNotice_suf: 'M',
    videoLoadingNotice: 'video uploading...',
    uploadVideo: 'upload video',
    videoTypeNotice: 'wrong video format',
    imageSizeNotice_pre: 'The picture supports up to ',
    imageSizeNotice_suf: 'M',
    imageTypeNotice: 'wrong image format',
    decisionNotice: 'Please select a decision',
    baAmountNotice: 'Please enter amount of debt canceled',
    collectionDateNotice: 'Please enter collection date',
    save: 'save',
    level: 'Complaint level',
    level_1: 'User fraud',
    level_2: 'collector fraud',
    level_3: 'Ordinary complaints',
    level_4: 'serious complaint',
    level_5: 'refuse communication',
    handleStatus: 'Processing status',
    handleStatus_0: 'in progress',
    handleStatus_1: 'completed',
    satisfaction: 'Satisfaction',
    satisfaction_0: 'none',
    satisfaction_1: 'Not satisfied',
    satisfaction_2: 'satisfy',
    userMobile: 'user input mobile',
    name: 'username',
    surname: 'User last name',
    appUser: 'User submission',
    backVisit: 'return visit',
    backVisit_0: 'No return visit',
    backVisit_1: 'Returned visit',
    connect: 'Connect',
    connect_0: 'Not connected',
    connect_1: 'Connected',
    complaintNum: 'number of complaints',
    backVisitNum: 'Number of return visits',
    connectNum: 'Number of connections',
    satisfactionNum: 'Number of satisfactory',
    connectRate: 'connection rate',
    satisfactionRate: 'Satisfaction',
    coverRate: 'Coverage',
    exportWithImage: 'Export(with pictures)',
    downloadWithImageNotice: 'Only single-day dates are supported',
    settle: 'Whether to pay',
    settle_all: 'all',
    settle_0: 'Unpaid',
    settle_1: 'Already paid',
    dataType: 'data type',
    dataType_commonData: 'Normal data',
    dataType_top10CollctionUserData: 'Data of the top 10 collectors',
    topNum: 'Several former',
    lastId: 'Last exported last ID',
    limitNum: 'Export volume',
    topStatus: 'Pinned situation',
    topStatus_0: 'Not pinned',
    topStatus_1: 'Need to be pinned',
    exportWithAllcolumns: 'Export all fields',
    tag: 'model tag',
    tag_1: 'violent collection',
    tag_2: 'stealing personal information',
    tag_3: 'low loan amount',
    tag_4: 'high interest rate',
    tag_5: 'short loan term',
    tag_6: 'fraud',
    tag_7: 'long review time',
    tag_8: 'the loan has not arrived',
    tag_9: 'repayment not shown',
    tag_10: 'loan refused',
    tag_11: 'not recommended',
    tag_12: 'early collection',
    tag_13: 'harassment contact',
    tag_14: 'App bug',
    tag_15: 'unable to repay',
    tag_16: 'slow loan arrival',
    tag_17: 'loan arrival failed',
    tag_18: 'delete account information',
    tag_19: 'cancel loan',
    tag_0: 'Number of records',
    settleStatus: 'settlement status',
    settleStatus_0: 'Unsettled',
    settleStatus_1: 'Early settlement',
    settleStatus_2: 'Normal Settlement',
    settleStatus_3: 'Late settlement',
    settleStatus_4: 'Extended settlement',
    settleStatus_5: 'Late Extended Settlement',
    settleStatus_6: 'Abnormal settlement',
    settleStatus_no: 'Don\'t differentiate',
    source: 'Data Sources',
    source_1: 'Customer service APP entry',
    source_2: 'web background entry',
    source_3: 'H5 page entry',
    source_4: 'Front-end customer service entry',
    approvalStatus: 'Approval Status',
    'approvalStatus_-1': 'unsubmitted',
    approvalStatus_0: 'Under machine review',
    approvalStatus_1: 'Machine review rejected',
    approvalStatus_2: 'Under manual approval',
    approvalStatus_3: 'Manual rejection',
    approvalStatus_4: 'Approved',
    approvalStatus_5: 'cancel',
    approvalStatus_6: 'Dawang Loan approved',
    aiType: 'AI type',
    aiType_0: 'unknown',
    aiType_1: 'complaint',
    aiType_2: 'consult',
    resolveStatus: 'Resolution status',
    resolveStatus_0: 'unsolved',
    resolveStatus_1: 'solved',
    frontSource: 'Front-end source page',
    frontSource_1: 'Home page not logged in',
    frontSource_2: 'Home page logged in',
    frontSource_3: 'Multi-product home page logged in',
    frontSource_4: 'my page',
    frontSource_5: 'info1',
    frontSource_6: 'info2',
    frontSource_7: 'info3',
    frontSource_8: 'info4',
    frontSource_9: 'info5',
    frontSource_10: 'Amount selection page',
    frontSource_11: 'under review',
    frontSource_12: 'Loan in progress',
    frontSource_13: 'Loan failed',
    frontSource_14: 'Review rejection',
    frontSource_15: 'Loan failure and rebind card page',
    frontSource_16: 'Pending repayment',
    frontSource_17: 'Late payment',
    frontSource_18: 'Order page',
    frontSource_19: 'Collection complaint page',
    orderType: 'Order Type',
    orderType_0: 'Single-period order',
    orderType_1: 'Instalment order',
    dictTextEn: 'English',
    dictTextEs: 'Spanish',
    dictTextFr: 'French',
    installmentSettleStatus_0: 'Unsettled',
    installmentSettleStatus_1: 'Settled',
    orderUnRepayAmount: 'Total amount not repaid',
    curCapital: 'Current principal',
    curRepayAmount: 'Current amount to be repaid',
    curOrderUnRepayAmount: 'Current total amount not repaid',
    toFinance: 'Transfer to Finance',
    toFinance_all: 'All',
    toFinance_0: 'No',
    toFinance_1: 'Yes',
    handleUser: 'Handle user',
    handleTime: 'Handle time',
    subject: 'Subject',
    information: 'Content',
  },
  es: {
    id: 'ID',
    country: 'quốc gia',
    createTime: 'thời gian tạo',
    custMobile: 'số điện thoại khách hàng',
    custEmail: 'email khách hàng',
    app: 'ứng dụng',
    status: 'trạng thái đơn hàng',
    status1: 'chưa xử lý',
    status2: 'đã xử lý',
    type: 'loại đơn hàng',
    firstLevelQuestion: 'nhãn cấp 1',
    secondLevelQuestion: 'nhãn cấp 2',
    complainChannel: 'kênh khiếu nại',
    custAppeal: 'đòi hỏi của khách hàng',
    attachmentCode: 'tập tin đính kèm',
    attachment: 'tập tin đính kèm',
    collectionDate: 'ngày thu hồi',
    collectionUser: 'người thu hồi',
    collectionMobile: 'số điện thoại người thu hồi',
    remark: 'ghi chú',
    action: 'hành động',
    custQueryData: 'Điện thoại/Email',
    createdTime: 'thời gian tạo',
    days: 'khoảng thời gian',
    workOrderDetail: 'chi tiết đơn hàng',
    status_0: 'thêm mới',
    status_1: 'đóng',
    status_2: 'đang xử lý bởi ATC',
    status_3: 'đang xử lý đóng tài khoản',
    status_4: 'đang xử lý thu hồi',
    status_5: 'đang xử lý sản phẩm',
    status_6: 'đang xử lý hệ thống',
    status_7: 'đang xử lý bởi quản lý dịch vụ khách hàng',
    type_1: 'khiếu nại',
    type_2: 'tư vấn',
    type_0: 'không xác định',
    firstLevelQuestion_1: 'Vấn đề APP',
    firstLevelQuestion_2: 'Thu hồi',
    firstLevelQuestion_3: 'Quảng cáo',
    firstLevelQuestion_4: 'Hủy tài khoản',
    firstLevelQuestion_5: 'Vay tiền',
    firstLevelQuestion_6: 'Trả nợ',
    firstLevelQuestion_7: 'Gia hạn',
    firstLevelQuestion_8: 'Hoàn tiền',
    secondLevelQuestion_1_1: 'Lỗi chức năng sản phẩm',
    secondLevelQuestion_1_2: 'Vấn đề địa phương hóa',
    secondLevelQuestion_1_3: 'Hướng dẫn sử dụng',
    secondLevelQuestion_1_4: 'Chỉnh sửa thông tin cá nhân',
    secondLevelQuestion_1_5: 'Tra cứu địa chỉ tải xuống',
    secondLevelQuestion_2_1: 'Thu hồi bạo lực',
    secondLevelQuestion_2_2: 'Lừa đảo người thu hồi',
    secondLevelQuestion_3_1: 'Lừa đảo quảng cáo',
    secondLevelQuestion_4_1: 'Xóa tài khoản',
    secondLevelQuestion_5_1: 'Thuế suất lãi suất',
    secondLevelQuestion_5_2: 'Số tiền vay',
    secondLevelQuestion_5_3: 'Chu kỳ trả nợ',
    secondLevelQuestion_5_4: 'Thời gian đến tài khoản',
    secondLevelQuestion_5_5: 'Từ chối vay',
    secondLevelQuestion_5_6: 'Hủy vay',
    secondLevelQuestion_6_1: 'Thanh toán chưa hiệu lực / Hệ thống lỗi không thể trả / Giới hạn chuyển tiền không thể trả / Nhiều lần trả / Tự động thu hồi',
    secondLevelQuestion_6_2: 'Tra cứu cách trả nợ / Tra cứu thông tin tín dụng',
    secondLevelQuestion_7_1: 'Thanh toán gia hạn được hiểu là thanh toán một phần / Thanh toán gia hạn đã thanh toán nhưng chưa hiệu lực',
    secondLevelQuestion_7_2: 'Tra cứu thanh toán gia hạn',
    secondLevelQuestion_8_1: 'Yêu cầu hoàn tiền',
    secondLevelQuestion_8_2: 'Tra cứu thời gian hoàn tiền',
    complainChannel_1: 'whatsapp',
    complainChannel_2: 'điện thoại',
    complainChannel_3: 'email',
    complainChannel_4: 'crisp',
    complainChannel_5: 'cơ quan quản lý',
    complainChannel_6: 'cơ cấu thanh toán',
    complainChannel_7: 'tòa án',
    complainChannel_8: 'kiểm sát viên',
    complainChannel_9: 'đường dây nóng thu hồi',
    complainChannel_10: 'được gửi bởi người dùng',
    custAppeal_1: 'phê duyệt nhanh',
    custAppeal_2: 'hoàn tiền',
    custAppeal_3: 'trả nợ bình thường',
    custAppeal_4: 'tăng hạn mức',
    custAppeal_5: 'nhận tiền nhanh',
    custAppeal_6: 'sử dụng app mượt',
    custAppeal_7: 'miễn giảm',
    custAppeal_8: 'thay đổi trạng thái đơn hàng',
    custAppeal_9: 'giảm lãi suất',
    custAppeal_10: 'giãn chu kỳ trả nợ',
    custAppeal_11: 'trì hoãn trả nợ',
    custAppeal_12: 'hủy đơn hàng vay',
    custAppeal_13: 'khác',
    canPass_1: 'có',
    canPass_2: 'không',
    item: 'mục',
    value: 'giá trị',
    lastTwoWeekValue: 'hai tuần trước',
    lastWeekValue: 'tuần trước',
    rate: 'tỷ lệ',
    dateLabel: 'nhãn ngày',
    reportType: 'loại',
    totalCount: 'tổng số đơn hàng',
    complaint: 'khiếu nại',
    consult: 'tư vấn',
    reportType_1: 'báo cáo hàng ngày',
    reportType_2: 'báo cáo hàng tuần',

    dictType: 'loại từ điển',
    dictKey: 'khóa từ điển',
    dictValue: 'giá trị từ điển',
    dictStatus: 'trạng thái từ điển',
    dictSort: 'sắp xếp từ điển',
    operate: 'hoạt động',
    dictStatus_0: 'kích hoạt',
    dictStatus_1: 'tắt',

    version: 'phiên bản',
    versionContent: 'nội dung phiên bản',
    forceUpdate: 'cập nhật bắt buộc hay không',
    downloadUrl: 'đường dẫn tải xuống',
    forceUpdate_0: 'không cập nhật bắt buộc',
    forceUpdate_1: 'cập nhật bắt buộc',
    updateTime: 'thời gian cập nhật',
    proportion: 'tỷ lệ',
    account: 'tài khoản ATC',
    questionV1: 'nhãn câu hỏi',
    inputOptRemark: 'Vui lòng nhập ghi chú hoạt động',
    optRemarkMustNotNull: "Ghi chú hoạt động không được để trống",
    optRemark: 'ghi chú hoạt động',
    questionV1_undefined: ' ',
    questionV1_0: ' ',
    questionV1_1: 'lỗi đơn hàng',
    questionV1_2: 'lỗi thanh toán',
    questionV1_3: 'OTP',
    questionV1_4: 'thu hồi bạo lực',
    questionV1_5: 'lừa đảo người thu hồi',
    questionV1_6: 'vấn đề quảng cáo',
    questionV1_7: 'Thời gian xác minh quá lâu',
    questionV1_8: 'Thời gian tiền vào tài khoản quá lâu',
    questionV1_9: 'Từ chối vay',
    questionV1_10: 'Hủy vay',
    questionV1_11: 'Thanh toán không hợp lệ',
    questionV1_12: 'Thanh toán lặp lại',
    questionV1_13: 'tự động thu hồi',
    questionV1_14: 'Xóa lịch sử tín dụng',
    questionV1_15: 'Hiểu gia hạn là thanh toán một phần',
    questionV1_16: 'Chỉnh sửa thông tin tài khoản',
    days_all: 'tất cả',
    days_yesterday: 'hôm qua',
    days_today: 'hôm nay',
    days_last7days: '7 ngày gần đây',
    days_last1month: 'tháng trước',
    days_other: 'khác',
    approve: 'phê duyệt',
    operateType: 'loại hoạt động',
    operateType_0: 'bị từ chối',
    operateType_1: 'được phê duyệt',
    operateType_2: 'chuyển cho thu hồi',
    operateType_3: 'thêm tài liệu',
    processFlow: 'luồng làm việc',
    nodeId: 'nút',
    businessNode: 'nút kinh doanh',
    businessNode_cs_receive_complaint: 'Dịch vụ khách hàng đã nhận được khiếu nại',
    businessNode_coll_receive_complaint: 'Thu hồi đã nhận được khiếu nại',
    businessNode_cs_add_work_order: 'Dịch vụ khách hàng đã tạo đơn hàng',
    businessNode_coll_add_work_order: 'Thu hồi đã tạo đơn hàng',
    businessNode_notice_coll: 'Hệ thống thông báo cho Thu hồi',
    businessNode_notice_ba: 'Hệ thống thông báo cho Đóng tài khoản',
    businessNode_notice_cs: 'Hệ thống thông báo cho Dịch vụ khách hàng',
    businessNode_notice_pro: 'Hệ thống thông báo cho Sản phẩm',
    businessNode_notice_cs_send_warning: 'Hệ thống thông báo cho ATC gửi thư cảnh báo',
    businessNode_cs_back_visit: 'ATC gọi lại khách hàng',
    businessNode_ba_approve: 'Đóng tài khoản phê duyệt đơn hàng',
    businessNode_coll_examine_coll_process: 'Giám đốc Thu hồi kiểm tra quá trình thu hồi',
    businessNode_pro_handle_problem: 'Phòng sản phẩm sửa chữa vấn đề',
    businessNode_notice_cs_manage: 'Hệ thống thông báo cho quản lý dịch vụ khách hàng',
    businessNode_cs_manage_replace_collection_user: 'Quản lý dịch vụ khách hàng thay đổi người thu hồi',
    itNode: 'nút IT',
    itNode_receive_complaint: 'nhận khiếu nại',
    itNode_add_work_order: 'thêm đơn hàng',
    itNode_notice_coll: 'thông báo cho Thu hồi',
    itNode_notice_cs: 'thông báo cho ATC',
    itNode_notice_ba: 'thông báo cho Đóng tài khoản',
    itNode_notice_pro: 'thông báo cho Sản phẩm',
    itNode_send_warning: 'gửi thư cảnh báo',
    itNode_approve: 'phê duyệt',
    itNode_cs_back_visit: 'ATC gọi lại khách hàng',
    itNode_coll_examine: 'kiểm tra bởi Thu hồi',
    itNode_notice_cs_manage: 'thông báo cho quản lý dịch vụ khách hàng',
    itNode_replace_collection_user: 'thay đổi người thu hồi',
    nodeType: 'loại nút',
    nodeType_0: 'nhận khiếu nại',
    nodeType_1: 'thêm đơn hàng',
    nodeType_2: 'thông báo',
    nodeType_3: 'phê duyệt',
    operater: 'người vận hành',
    flowStatus: 'trạng thái',
    flowStatus_0: 'đang tiến hành',
    flowStatus_1: 'đã đóng',
    repair: 'sửa chữa',
    repairNotice: 'Sửa chữa trường hợp luồng thẻ bị kẹt',
    operateTime: 'thời gian hoạt động',
    approveResult: 'nhận xét phê duyệt',
    uploadImage: 'tải lên hình ảnh',
    upload: 'tải lên',
    nextApproveRole: 'vai trò phê duyệt cấp dưới',
    approveRole_0: 'hệ thống',
    approveRole_1: 'dịch vụ khách hàng',
    approveRole_2: 'xóa nợ',
    approveRole_3: 'thu hồi',
    approveRole_4: 'sản phẩm',
    approveRole_5: 'quản lý dịch vụ khách hàng',
    nextApproveUser: 'người phê duyệt cấp dưới',
    hasImage: 'có hình ảnh',
    workFlowType: 'loại đơn hàng',
    workFlowType_common: 'thông thường',
    workFlowType_violentCollection: 'thu hồi bạo lực',
    workFlowType_violentCollectionForAppUser: 'thu hồi bạo lực',
    workFlowType_balanceAccountForCustomerService: 'vấn đề cân đối',
    workFlowType_balanceAccountForCollcetor: 'vấn đề cân đối',
    workFlowType_preLoan: 'vấn đề sản phẩm',
    workFlowType_commonForCustomerServiceManage: 'thông thường',
    workFlowType_violentCollectionForCustomerServiceManage: 'thu hồi bạo lực',
    workFlowType_balanceAccountForCustomerServiceManage: 'vấn đề cân đối',
    workFlowType_preLoanForCustomerServiceManage: 'vấn đề sản phẩm',
    baAmount: 'số tiền xóa nợ',
    decision: 'quyết định',
    decision_1: 'thay đổi người thu hồi',
    decision_2: 'phòng sản phẩm đã biết',
    decision_3: 'miễn giảm hoặc xóa nợ',
    decision_4: 'xóa nợ miễn phí toàn bộ',
    decision_5: 'xóa nợ với hoàn lại vốn',
    decision_6: 'gia hạn miễn phí',
    decision_7: 'gia hạn với miễn giảm',
    decision_8: 'hoàn tiền',
    decision_9: 'lừa đảo khách hàng',
    imageLoadingNotice: 'Đang tải hình ảnh...',
    operateTypeNotice: 'Vui lòng chọn nhận xét phê duyệt',
    productRemarkNotice: 'Vui lòng điền ghi chú',
    unknow: 'không biết',
    create: 'tạo đơn hàng',
    WorkOrderCreate: 'tạo đơn hàng',
    workOrderCreate: 'tạo đơn hàng',
    custId: 'ID khách hàng',
    orderNo: 'số đơn hàng',
    workFlowTypeNotice: 'Vui lòng chọn loại đơn hàng',
    questionV1Notice: 'Vui lòng chọn nhãn câu hỏi',
    approvelUserNotice: 'Vui lòng chọn người phê duyệt cấp dưới',
    custMobileAndCustEmailNotice: 'Vui lòng nhập số điện thoại hoặc email của khách hàng',
    appsNotice: 'Vui lòng chọn ứng dụng',
    complainChannelNotice: 'Vui lòng chọn kênh khiếu nại',
    processFlows: 'lịch sử lưu chuyển',
    video: 'video',
    videoPreviewNotice: 'Trình duyệt của bạn không hỗ trợ',
    videoSizeNotice_pre: 'Video hỗ trợ tối đa ',
    videoSizeNotice_suf: 'M',
    videoLoadingNotice: 'Đang tải video...',
    uploadVideo: 'tải lên video',
    videoTypeNotice: 'định dạng video sai',
    imageSizeNotice_pre: 'Hình ảnh hỗ trợ tối đa ',
    imageSizeNotice_suf: 'M',
    imageTypeNotice: 'lỗi định dạng hình ảnh',
    decisionNotice: 'Vui lòng chọn quyết định',
    baAmountNotice: 'Vui lòng nhập số tiền xóa nợ',
    collectionDateNotice: 'Vui lòng nhập ngày thu hồi',
    save: 'lưu',
    level: 'cấp độ khiếu nại',
    level_1: 'lừa đảo người dùng',
    level_2: 'lừa đảo người thu hồi',
    level_3: 'khiếu nại bình thường',
    level_4: 'khiếu nại nghiêm trọng',
    level_5: 'từ chối giao tiếp',
    handleStatus: 'trạng thái xử lý',
    handleStatus_0: 'đang tiến hành',
    handleStatus_1: 'hoàn thành',
    satisfaction: 'độ hài lòng',
    satisfaction_0: 'không',
    satisfaction_1: 'không hài lòng',
    satisfaction_2: 'hài lòng',
    userMobile: 'số điện thoại người dùng nhập',
    name: 'tên người dùng',
    surname: 'họ người dùng',
    appUser: 'được gửi bởi người dùng',
    backVisit: 'có gọi lại hay không',
    backVisit_0: 'chưa gọi lại',
    backVisit_1: 'đã gọi lại',
    connect: 'có kết nối hay không',
    connect_0: 'chưa kết nối',
    connect_1: 'đã kết nối',
    complaintNum: 'số lượng khiếu nại',
    backVisitNum: 'số lượng gọi lại',
    connectNum: 'số lượng kết nối',
    satisfactionNum: 'số lượng hài lòng',
    connectRate: 'tỷ lệ kết nối',
    satisfactionRate: 'độ hài lòng',
    coverRate: 'tỷ lệ phủ sóng',
    exportWithImage: 'xuất (với hình ảnh)',
    downloadWithImageNotice: 'chỉ hỗ trợ ngày đơn lẻ',
    settle: 'có thanh toán hay không',
    settle_all: 'tất cả',
    settle_0: 'chưa thanh toán',
    settle_1: 'đã thanh toán',
    dataType: 'loại dữ liệu',
    dataType_commonData: 'dữ liệu bình thường',
    dataType_top10CollctionUserData: 'dữ liệu 10 người thu hồi hàng đầu',
    topNum: 'mấy người đầu',
    lastId: 'ID cuối cùng đã xuất',
    limitNum: 'khối lượng xuất',
    topStatus: 'tình trạng ghim',
    topStatus_0: 'không ghim',
    topStatus_1: 'cần ghim',
    exportWithAllcolumns: 'xuất tất cả các trường',
    tag: 'nhãn mô hình',
    tag_1: 'thu hồi bạo lực',
    tag_2: 'cắp thông tin cá nhân',
    tag_3: 'số tiền thấp',
    tag_4: 'lãi suất cao',
    tag_5: 'thời hạn ngắn',
    tag_6: 'lừa đảo',
    tag_7: 'kiểm duyệt chậm',
    tag_8: 'tiền vay chưa đến',
    tag_9: 'thanh toán không hiển thị',
    tag_10: 'vay bị từ chối',
    tag_11: 'không khuyến nghị',
    tag_12: 'thu hồi sớm',
    tag_13: 'quấy rối liên hệ',
    tag_14: 'lỗi ứng dụng',
    tag_15: 'không thể thanh toán',
    tag_16: 'đến chậm',
    tag_17: 'không thể đến',
    tag_18: 'xóa thông tin tài khoản',
    tag_19: 'hủy vay',
    tag_0: 'số lượng bản ghi',
    settleStatus: 'trạng thái thanh toán',
    settleStatus_0: 'chưa thanh toán',
    settleStatus_1: 'thanh toán sớm',
    settleStatus_2: 'thanh toán bình thường',
    settleStatus_3: 'thanh toán muộn',
    settleStatus_4: 'thanh toán gia hạn',
    settleStatus_5: 'thanh toán muộn và gia hạn',
    settleStatus_6: 'thanh toán bất thường',
    settleStatus_no: 'không phân biệt',
    source: 'nguồn dữ liệu',
    source_1: 'nhập từ APP dịch vụ khách hàng',
    source_2: 'nhập từBackend web',
    source_3: 'nhập từ trang H5',
    source_4: 'nhập từ dịch vụ khách hàng front-end',
    approvalStatus: 'trạng thái phê duyệt',
    'approvalStatus_-1': 'chưaSubmit',
    approvalStatus_0: 'đang kiểm tra máy',
    approvalStatus_1: 'kiểm tra máy từ chối',
    approvalStatus_2: 'dưới phê duyệt thủ công',
    approvalStatus_3: 'từ chối thủ công',
    approvalStatus_4: 'đã phê duyệt',
    approvalStatus_5: 'hủy',
    approvalStatus_6: 'vay Dawang đã được phê duyệt',
    aiType: 'loại AI',
    aiType_0: 'không xác định',
    aiType_1: 'khiếu nại',
    aiType_2: 'tư vấn',
    resolveStatus: 'trạng thái giải quyết',
    resolveStatus_0: 'chưa giải quyết',
    resolveStatus_1: 'đã giải quyết',
    frontSource: 'trang nguồn front-end',
    frontSource_1: 'trang chủ chưa đăng nhập',
    frontSource_2: 'trang chủ đã đăng nhập',
    frontSource_3: 'trang chủ đa sản phẩm đã đăng nhập',
    frontSource_4: 'trang của tôi',
    frontSource_5: 'info1',
    frontSource_6: 'info2',
    frontSource_7: 'info3',
    frontSource_8: 'info4',
    frontSource_9: 'info5',
    frontSource_10: 'trang chọn số tiền',
    frontSource_11: 'dưới kiểm tra',
    frontSource_12: 'đang vay',
    frontSource_13: 'vay thất bại',
    frontSource_14: 'kiểm tra từ chối',
    frontSource_15: 'vay thất bại và trang ràng buộc thẻ mới',
    frontSource_16: 'chưa thanh toán',
    frontSource_17: 'thanh toán muộn',
    frontSource_18: 'trang đơn hàng',
    frontSource_19: 'trang khiếu nại thu hồi',
    orderType: 'loại đơn hàng',
    orderType_0: 'đơn hàng kỳ đơn',
    orderType_1: 'đơn hàng trả góp',
    dictTextEn: 'tiếng anh',
    dictTextEs: 'tiếng việt',
    dictTextFr: 'tiếng pháp',
    installmentSettleStatus_0: 'chưa giải quyết',
    installmentSettleStatus_1: 'đã giải quyết',
    orderUnRepayAmount: 'tổng số tiền chưa trả',
    curCapital: 'vốn hiện tại',
    curRepayAmount: 'số tiền phải trả hiện tại',
    curOrderUnRepayAmount: 'tổng số tiền chưa trả hiện tại',
    toFinance: 'chuyển tài chính',
    toFinance_all: 'tất cả',
    toFinance_0: 'không',
    toFinance_1: 'có',
    handleUser: 'người xử lý',
    handleTime: 'thời gian xử lý',
    subject: 'chủ đề',
    information: 'nội dung',
  },
}